import { render } from "./TransferDetail.vue?vue&type=template&id=eb2459b2&scoped=true"
import script from "./TransferDetail.vue?vue&type=script&lang=js"
export * from "./TransferDetail.vue?vue&type=script&lang=js"

import "./TransferDetail.vue?vue&type=style&index=0&id=eb2459b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2459b2"]])

export default __exports__